// extracted by mini-css-extract-plugin
export default {"layout":"SearchCites__layout___vB255","instructions":"SearchCites__instructions___Bpoyt","search":"SearchCites__search___Y_Yhp","input":"SearchCites__input___dC99x"};